import { ReactElement } from 'react';
import { S_Card } from '../../../design/card/card/S_Cards';
import { DashboardContainer } from '../../../modules/common/dashboard/DashboardContainer';
import { HeaderWithDescription } from '../../../modules/common/headerWithDescription/HeaderWithDescription';
import { TeamContainer } from '../../modules/team/containers/Team.container';

export const TeamView = (): ReactElement => (
  <DashboardContainer>
    <HeaderWithDescription header='Team' />
    <S_Card>
      <TeamContainer />
    </S_Card>
  </DashboardContainer>
);
